import { FaSearch } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import { toast } from 'react-toastify';

const SearchBar = ({
  short,
  style,
  searchString,
  setSearchString,
  onSearch,
}) => {
  const isMobile = useMediaQuery({ minWidth: 320, maxWidth: 768 });

  return (
    <section className='search__skew-container'>
      <form
        style={{ ...style, width: isMobile ? 'auto' : short ? '60%' : '100%' }}
        className='search__group-container'
        onSubmit={(e) => {
          e.preventDefault();

          if (searchString.length < 3) {
            toast.warning("Type at least 3 characters in the search box", {
              className: "toast__message",
              autoClose: 2000,
            });
            return;
          }
          onSearch();
        }}
      >
        <input
          placeholder='Search for any product'
          className='search__input'
          value={searchString || ''}
          required
          onChange={(e) => setSearchString(e.target.value)}
        />

        <button
          style={{ right: '.3%', top: '0%' }}
          className='search__btn'
          type='button'
          onClick={(e) => {
            e.preventDefault();
            if (searchString.length < 3) {
              toast.warning("Type at least 3 characters in the search box", {
                className: "toast__message",
                autoClose: 2000,
              });

              return;
            }
            onSearch();
          }}

        >
          <span style={{ transform: 'skewX(25deg) scaleX(-1)' }}>
            <FaSearch fontSize={'1.7rem'} />
          </span>
        </button>
      </form>
    </section>
  );
};

export default SearchBar;